import { checkRoutesContain, Routes } from '@/router/helpers/routeNames';

export function isProjectTemplateRoute(routeName: string | symbol | null | undefined): boolean {
  return checkRoutesContain(Routes.ProjectTemplate, routeName);
}
